import React from 'react'
import ReactModal from 'react-modal'

import { Header } from './styles'
import Icon from '../Icon'
import Button from '../Button'
import Text from '../Text'
import { theme } from '../../config/theme'

ReactModal.setAppElement('#root')

interface Props {
  title?: string
  open: boolean
  small?: boolean
  onToggle: (open: boolean) => void
}

const Modal: React.FC<Props> = ({
  title = '',
  open = false,
  small = false,
  children,
  onToggle,
}) => {
  const style: ReactModal.Styles = {
    content: {
      left: 0,
      right: 0,
      top: small ? '30vh' : '10vh',
      bottom: 'unset',
      minHeight: small ? 'unset' : '50vh',
      maxHeight: small ? '70vh' : '90vh',
      width: small ? '500px' : '800px',
      zIndex: 1001,
      display: 'flex',
      border: `1px solid ${theme.color.lightGray}`,
      flexDirection: 'column',
      margin: 'auto',
      borderRadius: '5px',
      background: 'white',
      padding: 0,
      paddingBottom: '5px',
    },
    overlay: {
      background: 'rgba(0, 0, 0, 0.6)',
      zIndex: 1001,
    },
  }

  if (matchMedia(`(max-width: ${theme.mediaQueries.home})`).matches) {
    style.content!.top = small ? '20vh' : '10vh'
    style.content!.left = small ? '20vh' : '10vh'
    style.content!.maxHeight = 'unset'
    style.content!.width = 'unset'
    style.content!.bottom = small ? 'unset' : '10vh'
    style.content!.right = small ? '20vw' : '0'
  }

  return (
    <ReactModal
      isOpen={open}
      onRequestClose={() => onToggle(false)}
      style={style}
      contentLabel={title}
    >
      <Header>
        <Button
          label={(
            <Icon
              name="close"
            />
          )}
          backgroundColor="transparent"
          smallPadding
          onClick={() => onToggle(false)}
        />

        <Text
          tag="h2"
          align="center"
        >
          {title}
        </Text>
      </Header>

      {children}
    </ReactModal>
  )
}

export default Modal
